import { isDev } from '@/util/env';
import { FC } from 'react';
import {
    ErrorBoundary as ReactErrorBoundary,
    ErrorBoundaryProps as ReactErrorBoundaryProps,
} from 'react-error-boundary';
import ErrorMessage from './ErrorMessage';

export type ErrorBoundaryProps = {
    fallback?: ReactErrorBoundaryProps['fallback'];
    message?: string;
    children: JSX.Element;
};

const ErrorBoundary: FC<ErrorBoundaryProps> = ({
    fallback,
    message,
    children,
    ...props
}) => {
    // For dev, we usually want to see the errors and maintain state - so by
    // default, we bypass this component.
    // To test the prod error-handling experience, just comment out this line.
    if (isDev) return children;

    return (
        <ReactErrorBoundary
            fallback={
                fallback ?? (
                    <ErrorMessage message={message ?? DEFAULT_MESSAGE} />
                )
            }
            {...props}
        >
            {children}
        </ReactErrorBoundary>
    );
};

const DEFAULT_MESSAGE =
    'Whoops! Something went wrong. Please refresh and try again.';

export default ErrorBoundary;
